module.exports = __webpack_public_path__ + "../static/img/dashboards_logo.2abed445.png";